export default {"src":"/_next/static/media/service.effc055e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};